module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"filters":"Filters","apply":"Apply","cancel":"Cancel","clear":"Clear"},"ja":{"filters":"フィルター","apply":"適応","cancel":"キャンセル","clear":"クリア"}}')
  delete Component.options._Ctor
}
